"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextContent = exports.PieChartWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const TextContent = exports.TextContent = /*#__PURE__*/(0, _base.default)("g", process.env.NODE_ENV === "production" ? {
  target: "e14yfkwz1"
} : {
  target: "e14yfkwz1",
  label: "TextContent"
})(process.env.NODE_ENV === "production" ? {
  name: "oldbq4",
  styles: "user-select:none"
} : {
  name: "oldbq4",
  styles: "user-select:none",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const PieChartWrapper = exports.PieChartWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e14yfkwz0"
} : {
  target: "e14yfkwz0",
  label: "PieChartWrapper"
})(({
  width = '100%',
  height = '300px'
}) => /*#__PURE__*/(0, _react.css)("width:", width, ";height:", height, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PieChartWrapper;")));